import { render } from "./summaryTabOrderDetails.vue?vue&type=template&id=6acac19a&ts=true"
import script from "./summaryTabOrderDetails.vue?vue&type=script&lang=ts"
export * from "./summaryTabOrderDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__